<ng-container *ngIf="(isHiringManager$ | async) === false && !isWidgetView">
  <mojo-shared-job-matches-phases
    [jobId]="(job$ | async).id"
    (statusesChange)="statusesChange($event)"
    [enableLinks]="false"
  >
  </mojo-shared-job-matches-phases>
</ng-container>

<ng-container *mojoHasPrivilege="privileges.assigned.candidates">
  <div
    *ngIf="{
        job: job$ | async,
        statusesConfiguration: statusesConfiguration$ | async
      } as data"
    [class.job-assigns-container]="showContainerBorder"
  >
    <mojo-batch-operation-toolbar
      *ngIf="!isWidgetView"
      [availableIds]="allAvailableDirectApplicantsIds$ | async"
    >
      <mojo-batch-operation-submit-hiring-manager-review
        *ngIf="hiringManagerFlow$ | async"
        [isNotDisabled]="isSubmitToHiringManagerAvailable$ | async"
        [jobId]="data.job.id"
      >
      </mojo-batch-operation-submit-hiring-manager-review>
      <mojo-batch-operation-reject-candidate
        [isNotDisabled]="isRejectingAvailable$ | async"
        [jobId]="data.job.id"
      >
      </mojo-batch-operation-reject-candidate>
    </mojo-batch-operation-toolbar>
    <ng-template
      #candidateItem
      let-item
    >

      <mojo-assigns-candidate-container
        [assigned]="item"
        [expandedView]="expandedView"
        [job]="data.job"
        [hiringManagerFlow]="hiringManagerFlow$ | async"
        [isWidgetView]="isWidgetView"
        [prospectTab]="isProspectTab"
      >
      </mojo-assigns-candidate-container>
    </ng-template>

    <mat-progress-bar
      mode="indeterminate"
      *ngIf="(list$ | async) === false"
    ></mat-progress-bar>

    <ng-container *ngIf="!expandedView else associationsContainer">
      <ng-container *ngIf="(currentRoute$ | async) === 'shortlist' && (isHiringManager$ | async) === false
        else associationsContainer">
      </ng-container>
    </ng-container>

    <ng-template #associationsContainer>
      <mojo-collection
        [overflowHidden]="false"
        *ngIf="(isMobileViewService.isMobileView$() | async) === false && (list$ | async)?.length > 0 || (isFullPageView$ | async) === true"
      >

        <mat-accordion class="expantion-transition">
          <mat-expansion-panel
            class="mat-expantion-tpanel"
            [expanded]="true"
            (click)="expandedData()"
            [disabled]="isShorlistPage"
          >
            <mat-expansion-panel-header class="team-members">
              <mojo-job-assign-collection-header
                [showHeaderOnMobile]="(isFullPageView$ | async) === false"
                [showSeeAll]="(isFullPageView$ | async) === false && (pagination$ |
            async)?.totalElements > defaultPageSize"
                [totalElements]="(pagination$ | async)?.totalElements"
                [hideFilters]="(isFullPageView$ | async) === false"
                [statuses]="statuses$ | async"
                (statusesChange)="statusesChange($event)"
                mojo-collection-header
                [isExpandible]="(currentRoute$ | async) !== 'shortlist'"
                [expanded]="isPanelOpen"
                [totalElementsOnList]="totalCandidates$ | async"
              >
              </mojo-job-assign-collection-header>
            </mat-expansion-panel-header>

            <mojo-loader *ngIf="(isLoading$ | async); else contentList">
            </mojo-loader>
            <ng-template #contentList>
              <mojo-collection-list
                [items]="list"
                *ngIf="list?.length > 0; else empty"
                [itemTemplate]="candidateItem"
                class="without-padding"
              >
              </mojo-collection-list>

              <ng-template #empty>
                <div class="no-content-container">
                  <mojo-no-content [message]="emptyMessage"></mojo-no-content>
                </div>

              </ng-template>

            </ng-template>
          </mat-expansion-panel>
        </mat-accordion>

      </mojo-collection>

      <mojo-pagination
        *ngIf="expandedView"
        [pagination]="pagination$ | async"
        (pageChange)="pageChange($event)"
      >
      </mojo-pagination>
    </ng-template>
